/**
 * Zelf Zorgen Samen Doen
 *
 * @author Robuust
 * @author Rutger Bakker <rutger@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';
import { gsap } from 'gsap';

/**
 * GSAP controller
 */
export default class extends Controller {
  static targets = ['video'];

  /**
   * GSAP context.
   */
  ctx = null;

  /**
   * Initialize the controller.
   */
  initialize() {
    this.ctx = gsap.context(() => {});
  }

  /**
   * Connect the Controller.
   */
  connect() {
    this.ctx.add(() => {
      // Video pin and clip path animation
      if (this.hasVideoTarget) {
        gsap.fromTo(this.videoTarget, {
          clipPath: 'inset(30% round 150px)',
        }, {
          clipPath: 'inset(0% round 0px)',
          ease: 'none',
          scrollTrigger: {
            trigger: this.videoTarget.parentNode,
            start: 'top top',
            end: () => `+=${window.innerHeight * 1}`,
            pin: this.videoTarget.parentNode,
            scrub: 1,
            onEnter: () => { this.videoTarget.play(); },
          },
        });
      }
    });
  }

  /**
   * Disconnect the controller.
   */
  disconnect() {
    this.ctx.revert();
  }
}
